module.exports = __webpack_public_path__ + "img/inno_1.4b1c984f.jpg";